<template>
    <div class="editor">
        <div class="content-wrapper">
        <!--<div class="drawer-type pl-0">{{ lang['general.model_settings'] }}</div>-->
            <div class="mb-3">
                <div v-if="nameError" class="alert alert-danger my-2" role="alert">
                    {{ lang['model.model_name_error'] }}
                </div>
                <label for="model-name" class="section-heading">{{ lang['model.name'] }}</label>
                <input id="model-name" class="form-control" type="text" v-model="data.name" @keyup="resetError('name')">
            </div>
            <div class="edit-row mb-2">
                <label for="is-open">{{ lang['model.share_with_org'] }}</label>
                <label class="switch">
                    <input type="checkbox" v-model="shareWithOrg">
                    <span class="slider-switch round"></span>
                </label>
            </div>

            <div class="edit-row mb-2">
                <label for="is-open">{{ lang['model.share_public'] }}</label>
                <label class="switch">
                    <input type="checkbox" v-model="sharePublic">
                    <span class="slider-switch round"></span>
                </label>
            </div>

            <div>
                <div v-if="descError" class="alert alert-danger my-2" role="alert">
                    {{ lang['model.model_desc_error'] }}
                </div>

                <label for="description" class="section-heading">{{ lang['model.description'] }}</label>
                <div class="edit-row mb-2">
                    <textarea class="form-control" name="" id="" rows="5" v-model="data.description" @keyup="resetError('desc')"></textarea>
                </div>

                <label for="final-question" class="section-heading">{{ lang['model.final_question_single_choice'] }}</label>
                <div class="edit-row mb-2">
                    <textarea class="form-control" name="" id="" rows="5" v-model="data.single_question" :placeholder="singlePlaceHolder"></textarea>
                </div>

                <label for="final-question" class="section-heading">{{ lang['model.final_question_group_choice'] }}</label>
                <div class="edit-row mb-2">
                    <textarea class="form-control" name="" id="" rows="5" v-model="data.group_question" :placeholder="groupPlaceHolder"></textarea>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props:['model', 'content'],
    data() {
        return {
            data: this.content,
            nameError: false,
            descError: false,
            singlePlaceHolder: lang['model.final_question_single_placeholder'],
            groupPlaceHolder: lang['model.final_question_group_placeholder'],
            lang: lang,
            shareWithOrg: false,
            sharePublic: false,
        }
    },

    mounted() {
        this.shareWithOrg = this.content.share_with_org,
        this.sharePublic = this.content.share_public,
        bus.$on('save', this.save);
    },

    methods: {
        closeEditor() {
            this.$emit('close', this.item);
        },

        resetError(field) {
            switch(field) {
                case 'name':
                    this.nameError = false;
                    break;
                case 'desc':
                    this.descError = false;
                    break;
            }
        },

        save() {
            const { name, description } = this.data;
            this.nameError = !name.trim().length > 0
            this.descError = !description.trim().length > 0
            if(!this.nameError && !this.descError) {
                this.data.share_with_org = this.shareWithOrg ? 1 : 0;
                this.data.share_public = this.sharePublic ? 1 : 0;
                $.post('/models', this.data,
                (response) => {
                    if(!response.error) {
                        this.closeEditor();
                        $('.organization').text(name);
                    }
                })
                .catch((error) => {
                    bus.$emit('popupError', error);
                });
            }
        }
    }
}
</script>
